/* eslint-disable camelcase */

export default {
    fr: {
        advanceScreening      : 'Avant-première',
        nowBooking            : 'A l\'affiche',
        festival              : 'Festival',
        specials              : 'Séances spéciales',
        cast                  : 'Avec',
        director              : 'Réalisateur',
        producers             : 'Producteurs',
        writers               : 'Auteurs',
        distributors          : 'Distributeurs',
        noShowtimes           : 'Ce film ne dispose plus de séances dans les cinémas de la région',
        newThisWeek           : 'Nouveautés',
        durationMinutes       : ' min. ',
        allMovies             : 'Tous les films',
        countries: {
            lu                  : 'Luxembourg',
            fr                  : 'France',
            de                  : 'Allemagne',
            be                  : 'Belgique'
        },
        languages: {
            'V.O.'              : 'V.O.',
            fr                  : 'Français',
            de                  : 'Allemand'
        },
        subtitles: {
            fr                  : 'FR',
            en                  : 'EN',
            nl                  : 'NL'
        },
        countriesPickerTitle  : 'Pays',
        audioPickerTitle      : 'Audio',
        subtitlesPickerTitle  : 'Sous-titres'
    },

    en: {
        advanceScreening      : 'Preview',
        nowBooking            : 'Now showing',
        festival              : 'Festival',
        specials              : 'Special screenings',
        cast                  : 'With',
        director              : 'Director',
        producers             : 'Producers',
        writers               : 'Writers',
        distributors          : 'Distributors',
        noShowtimes           : 'This movie is not screened anymore',
        newThisWeek           : 'New this week',
        durationMinutes       : ' min. ',
        allMovies             : 'All films',
        countries: {
            lu                  : 'Luxembourg',
            fr                  : 'France',
            de                  : 'Germany',
            be                  : 'Belgium'
        },
        languages: {
            'V.O.'              : 'O.V.',
            fr                  : 'French',
            de                  : 'German'
        },
        subtitles: {
            fr                  : 'FR',
            en                  : 'EN',
            nl                  : 'NL'
        },
        countriesPickerTitle  : 'Country',
        audioPickerTitle      : 'Audio',
        subtitlesPickerTitle  : 'Subtitles'
    },

    de: {
        advanceScreening      : 'Vorpremiere',
        nowBooking            : 'Laufende Filme',
        festival              : 'Festival',
        specials              : 'Sondervorführungen',
        cast                  : 'Mit',
        director              : 'Regie',
        producers             : 'Produzent',
        writers               : 'Autoren',
        distributors          : 'Vertrieb',
        noShowtimes           : 'Dieser Film ist nicht mehr im Programm',
        newThisWeek           : 'Neue Filme',
        durationMinutes       : ' Min. ',
        allMovies             : 'Alle Filme',
        countries: {
            lu                  : 'Luxemburg',
            fr                  : 'Frankreich',
            de                  : 'Deutschland',
            be                  : 'Belgien'
        },
        languages: {
            'V.O.'              : 'O.V.',
            fr                  : 'Französisch',
            de                  : 'Deutsch'
        },
        subtitles: {
            fr                  : 'FR',
            en                  : 'EN',
            nl                  : 'NL'
        },
        countriesPickerTitle  : 'Land',
        audioPickerTitle      : 'Audio',
        subtitlesPickerTitle  : 'Untertitel'
    },

    pt: {
        advanceScreening      : 'Ante-estreia',
        nowBooking            : 'Cartaz',
        festival              : 'Festival',
        specials              : 'Sessão especial',
        cast                  : 'Com',
        director              : 'Realizador',
        producers             : 'Produtor',
        writers               : 'Autor',
        distributors          : 'Distribuidor',
        noShowtimes           : 'Este filme ão está disponível nos cinemas da região',
        newThisWeek           : 'Novidades',
        durationMinutes       : ' min. ',
        allMovies             : 'Todos os filmes',
        countries: {
            lu                  : 'Luxemburgo',
            fr                  : 'França',
            de                  : 'Alemanha',
            be                  : 'Bélgica'
        },
        languages: {
            'V.O.'              : 'V.O.',
            fr                  : 'Francês',
            de                  : 'Alemão'
        },
        subtitles: {
            fr                  : 'FR',
            en                  : 'EN',
            nl                  : 'NL'
        },
        countriesPickerTitle  : 'País',
        audioPickerTitle      : 'Auditivo',
        subtitlesPickerTitle  : 'Legendas'
    }
}



// WEBPACK FOOTER //
// ./js/movies/IntlMessages.js